export default __webpack_public_path__ + "static/media/CMM-Logo.ee840b71.png";